export default __webpack_public_path__ + "static/media/Scholar's Pants of the Crescent.902be672.jpg";